import { Component, inject, OnInit } from '@angular/core';
import { SettingsService } from '@delon/theme';
import {
  IonAvatar,
  IonContent,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonMenu,
  IonMenuToggle,
  IonToolbar
} from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { chevronForwardOutline, gridOutline } from 'ionicons/icons';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.less'],
  imports: [IonIcon, IonItem, IonMenu, IonToolbar, IonHeader, IonLabel, IonContent, IonList, IonMenuToggle, IonAvatar]
})
export class SidebarComponent implements OnInit {
  protected settings = inject(SettingsService);
  constructor() {
    addIcons({
      chevronForwardOutline,
      gridOutline
    });
  }

  ngOnInit() {}
}
